























import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { DataApi } from '../models/AtencionesBase.model';

@Component({ components: { GridComponent: AgGridVue } })
export default class SeriesTab extends Vue {
  @Prop({ required: true, default: [] }) data!: DataApi[];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  listData: any = [];
  quickSearch: string = '';

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.data);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }

  private colsGrid(): ColDef[] {
    const fields = [
      'Fecha Instalación',
      'EPC',
      'CRM Producto',
      'CRM Plataforma',
      'CRM EP',
      'CRM Serie',
      'CRM Flota',
      'CRM Patente',
      'Equipo',
      'Serie Número',
      'Activa Número',
      'Estado Cuadratura',
    ];

    return Object.keys(this.data[0])
      .filter(col => !['ndvnumero', 'STATUS', 'TOTAL_REGISTROS'].includes(col))
      .map((col, i) => {
        let cb = null;
        if (col === 'encontrado') {
          cb = {
            cellRenderer: (params: any) =>
              this.iconState({ encontrado: params.data.encontrado }),
          };
        }

        return {
          headerName: fields[i],
          field: col,
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 220,
          minWidth: 100,
          ...cb,
        };
      });
  }

  iconState({ encontrado = 'f' }): string {
    return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
      encontrado.toLowerCase() === 't' ? 'rgb(42 255 78)' : 'rgb(255 58 58)'
    }"></i>`;
  }
}
